export default __webpack_public_path__ + "static/media/soft-web-solution.847731e4.jpg";